/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { UserWithRoles } from "./UserWithRoles";
export const UserWithRolesResponse = core.serialization.object({
    data: UserWithRoles,
});
